import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { RequestType, requestStatus, requestTypeDetail, requestTypes } from "../../../../../constants";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { downloadExcel } from "react-export-table-to-excel";
import { TableHelpers } from "../../../../../helper/TableHelper";

export const useDemandSupplyColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "150px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <div className={`flag ${requestTypeDetail[text as RequestType]?.flag}`}>{requestTypes[text]}</div>
      ),
      width: "100px",
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      onCell: () => {
        return {
          style: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "400px", // optional max width to constrain very long content
          },
        };
      },
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "150px",
      render: (text: string) => <ApprovalStatus status={text} isDemand={true} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã tiếp nhận",
          value: requestStatus.acceptance,
        },
        {
          text: "Tiến hành thực hiện",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const header = [
              "Nội dung",
              "Đơn vị tính",
              "Số lượng đề nghị",
              "Thời gian dự kiến sử dụng",
              "Ghi chú/Giải trình",
            ];
            const body = JSON.parse(record.eContent);
            const mappedBody = body.map((record: any) => {
              const { id, ...bodyWithoutId } = record;
              return bodyWithoutId;
            });
            downloadExcel({
              fileName: "DS_Cap_VatTu_" + record.id,
              sheet: "Sheet1",
              tablePayload: {
                header,
                body: mappedBody,
              },
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
